import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ListItemTest from "../common/ListItemTest";
import ShortcutLink from "../common/ShortcutLink";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {BrandContext} from "../common/BrandContext";
import {UserContext} from "../common/UserContext";
import Button from "../common/Button";
import ButtonSelect from "../common/ButtonSelect";

const TeacherTestsDashboardWidget = props => {
    const brandConfig = useContext(BrandContext);
    const {user, setUser} = useContext(UserContext);
    const [tests, setTests] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const [testOwnerSearchType, setTestOwnerSearchType] = useState('TEACHER');
    const [testPurpose, setTestPurpose] = useState('ALL');

    const testPurposes = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'DIAGNOSTIC_TEST', label: 'Diagnostic'},
        {value: 'EXAM', label: 'Exam'}
    ];

    const ownerSearchTypes = [
        {value: 'TEACHER', label: 'own'},
        {value: 'CLASSES', label: 'my classes'},
        {value: 'SCHOOL', label: 'school'}
    ];

    useEffect(() => {
        setLoading(true);
        if (testOwnerSearchType !== undefined) {
            axios.post('/web/ui/test/searchTeacherTests', {testOwnerSearchType: testOwnerSearchType, testPurpose: testPurpose === 'ALL' ? undefined : testPurpose})
                .then(response => {
                    setTests(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [testOwnerSearchType, testPurpose]);

    const handleTestPurposeChange = selectedOption => {
        setTestPurpose(selectedOption.value);
    }

    const handleOwnerChange = selectedOption => {
        if (selectedOption.value !== undefined) {
            setTestOwnerSearchType(selectedOption.value);
        }
    }

    const createTestFromDashBoard = () => {
        globalReactFunctions.createTestFromDashboard = true;
        loadShortcutByUrl('/web/ui/view/teacherAssessments');
    }

    const createTestAssignmentFromDashBoard = (testId) => {
        globalReactFunctions.createTestAssignmentFromDashboard = true;
        globalReactFunctions.testId = testId;
        loadShortcutByUrl('/web/ui/view/teacherAssessments');
    }

    return (
        <DashboardWidget
            title={
                <>
                    <svg className="ch-icon-sm" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/teacherAssessments'}>
                        <span>Tests</span>
                    </ShortcutLink>
                </>
            }
            isLoading={isLoading}
            headerActions={
                <>
                    <Button size="small" onClick={createTestFromDashBoard}>Create a test</Button>
                    {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                        <ButtonSelect title="Type" position="right" size="small" options={testPurposes} value={testPurpose !== undefined ? testPurposes.find(o => o.value === testPurpose) : 'ALL'} onChange={handleTestPurposeChange}/>
                    }
                    <ButtonSelect title="Created by" position="right" size="small" options={ownerSearchTypes} value={testOwnerSearchType !== undefined ? ownerSearchTypes.find(o => o.value === testOwnerSearchType) : 'TEACHER'} onChange={handleOwnerChange}/>
                </>
            }
        >
            <div className={'ch-dashboard-blk-body'}>
                {tests.length > 0 &&
                    <div className={'ch-testAssignments'}>
                        <table className={'ch-dashboard-widget-table ch-table'}>
                            <thead>
                                <tr>
                                    <th>{brandConfig.testName}</th>
                                    <th>Questions</th>
                                    <th>Created by</th>
                                    <th>In use</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tests.map((test) => (
                                    <ListItemTest key={test.testId} test={test} brandConfig={brandConfig} actionOnClick={function () {createTestAssignmentFromDashBoard(test.testId)}} />
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                {tests.length == 0 &&
                    <div className="ch-list-item-disabled">No tests found</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default TeacherTestsDashboardWidget;